<template>
  <section id="portfolio" class="py-5">
      <div class="container">
        <div class="shadow-lg p-3 mb-5 bg-body-tertiary rounded">
        <h2 class="mb-0">Compétences et Expériences</h2></div>
        <!-- Developpement -->
        
        <div class="row align-items-center gy-4 mt-4">
          <div class="col-12 col-md-7">
            <h5>Compétences informatique</h5>
            <!-- Progress bar -->
            <div class="mb-3 p-3 bg-white rounded-3 shadow-sm">
              <div class="row align-items-center">
                <div class="col-5 col-sm-4 col-lg-3 col-xl-2">
                  <div class="d-flex align-items-center">
                    <font-awesome-icon icon="fa-brands fa-html5" />
                    <p class="fw-bold m-0">HTML5</p>
                  </div>
                </div>
                <div class="col">
                  <div class="progress" data-bs-toggle="tooltip" title="75%">
                    <div class="progress-bar w-75" role="progressbar" aria-valuenow="90" aria-valuemin="0"
                         aria-valuemax="100">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3 p-3 bg-white rounded-3 shadow-sm">
              <div class="row align-items-center">
                <div class="col-5 col-sm-4 col-lg-3 col-xl-2">
                  <div class="d-flex align-items-center">
                    <font-awesome-icon icon="fa-brands fa-css3-alt"/>
                    <p class="fw-bold m-0">CSS3</p>
                  </div>
                </div>
                <div class="col">
                  <div class="progress" data-bs-toggle="tooltip" title="75%">
                    <div class="progress-bar w-75" role="progressbar" aria-valuenow="95" aria-valuemin="0"
                         aria-valuemax="100">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3 p-3 bg-white rounded-3 shadow-sm">
              <div class="row align-items-center">
                <div class="col-5 col-sm-4 col-lg-3 col-xl-2">
                  <div class="d-flex align-items-center">
                    <font-awesome-icon icon="fa-brands fa-js" />
                    <p class="fw-bold m-0">JS</p>
                  </div>
                </div>
                <div class="col">
                  <div class="progress" data-bs-toggle="tooltip" title="75%">
                    <div class="progress-bar w-50" role="progressbar" aria-valuenow="50" aria-valuemin="0"
                         aria-valuemax="100">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3 p-3 bg-white rounded-3 shadow-sm">
              <div class="row align-items-center">
                <div class="col-5 col-sm-4 col-lg-3 col-xl-2">
                  <div class="d-flex align-items-center">
                    <font-awesome-icon icon="fa-brands fa-php" />
                    <p class="fw-bold m-0">PHP</p>
                  </div>
                </div>
                <div class="col">
                  <div class="progress" data-bs-toggle="tooltip" title="75%">
                    <div class="progress-bar w-75" role="progressbar" aria-valuenow="95" aria-valuemin="0"
                         aria-valuemax="100">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3 p-3 bg-white rounded-3 shadow-sm">
              <div class="row align-items-center">
                <div class="col-5 col-sm-4 col-lg-3 col-xl-2">
                  <div class="d-flex align-items-center">
                    <font-awesome-icon icon="fa-brands fa-java" />
                    <p class="fw-bold m-0">JAVA</p>
                  </div>
                </div>
                <div class="col">
                  <div class="progress" data-bs-toggle="tooltip" title="50%">
                    <div class="progress-bar w-50" role="progressbar" aria-valuenow="50" aria-valuemin="0"
                         aria-valuemax="100">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="mb-3 p-3 bg-white rounded-3 shadow-sm">
              <div class="row align-items-center">
                <div class="col-5 col-sm-4 col-lg-3 col-xl-2">
                  <div class="d-flex align-items-center">
                    <font-awesome-icon icon="fa-brands fa-python" />
                    <p class="fw-bold m-0">PYTHON</p>
                  </div>
                </div>
                <div class="col">
                  <div class="progress" data-bs-toggle="tooltip" title="50%">
                    <div class="progress-bar w-50" role="progressbar" aria-valuenow="50" aria-valuemin="0"
                         aria-valuemax="100">
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
          <div class="col-12 offset-md-1 col-md-4 ">
            <div>
            <font-awesome-icon icon="fa-brands fa-linux" class="mg" />&nbsp;&nbsp;&nbsp;
            <font-awesome-icon icon="fa-brands fa-windows" class="mg" />&nbsp;&nbsp;&nbsp;
            <font-awesome-icon icon="fa-brands fa-github" class="mg" /><br>&nbsp;&nbsp;&nbsp;
          </div>
          <div class="">
            <img src="../assets/react.png" alt="écran montrant des designs" width="90" class="rounded-3 shadow">&nbsp;&nbsp;&nbsp;
            <img src="../assets/node.png" alt="écran montrant des designs" width="90" class="rounded-3 shadow">&nbsp;&nbsp;&nbsp;
            <img src="../assets/canva.png" alt="écran montrant des designs" width="100" class="rounded-3 shadow"><br>&nbsp;&nbsp;&nbsp;
          </div>
          <div>
            <img src="../assets/mysql.png" alt="écran montrant des designs" width="100" class="rounded-3 shadow ">&nbsp;&nbsp;&nbsp;
            <img src="../assets/oracle.png" alt="écran montrant des designs" width="100" class="rounded-3 shadow">&nbsp;&nbsp;&nbsp;
            <img src="../assets/thMongo.png" alt="écran montrant des designs" width="100" class="rounded-3 shadow"><br>&nbsp;&nbsp;&nbsp;
          </div>
            <img src="../assets/office.png" alt="écran montrant des designs" width="100" class="rounded-3 shadow">&nbsp;&nbsp;&nbsp;
            <img src="../assets/uml.png" alt="écran montrant des designs" width="90" class="rounded-3 shadow">&nbsp;&nbsp;&nbsp;
            <img src="../assets/xammpp.png" alt="écran montrant des designs" width="90" class="rounded-3 shadow">&nbsp;&nbsp;&nbsp;
          
          </div>
        </div>

        <!-- Design -->
        <div class="row align-items-center gy-4 mt-4">
          <div class="col-12 col-md-4">
            <div class="card">
                <div class="card-body">
                    <h5 class="">Expériences professionnelles</h5>
                    <div class="list-group text-start">
                      <a href="#" class="list-group-item list-group-item-action">
                        <div class="d-flex w-100 justify-content-between">
                        <span class="mb-1 card-title">Développeuse web fullstack Chez Ayokai</span>
                        <small class="text-end">Depuis Avril</small>
                        </div>
                    </a>
                    <a href="#" class="list-group-item list-group-item-action" aria-current="true">
                        <div class="d-flex w-100 justify-content-between">
                        <span class="mb-1 card-title">Agent d'entretien </span>
                        <small class="text-end">3 mois </small>
                        </div>
        
                    </a>
                    <a href="#" class="list-group-item list-group-item-action">
                        <div class="d-flex w-100 justify-content-between">
                        <span class="mb-1 card-title">Développeuse web Python Django et Javascript</span>
                        <small class="text-end">3 mois</small>
                        </div>
                    </a>
                    </div>
                    <h5 class="">Expériences associatives </h5>
                    <div class="list-group">
                    <a href="#" class="list-group-item list-group-item-action" aria-current="true">
                        <div class="d-flex w-100 justify-content-between">
                        <span class="mb-1 card-title">Chargé de communication</span>
                        <small>EILTech Calais </small>
                        </div>
        
                    </a>
                    <a href="#" class="list-group-item list-group-item-action">
                        <div class="d-flex w-100 justify-content-between">
                        <span class="mb-1 card-title">Membre actif </span>
                        <small >EILCook Calais</small>
                        </div>
                    </a>
                    <a href="#" class="list-group-item list-group-item-action">
                        <div class="d-flex w-100 justify-content-between">
                        <span class="mb-1 card-title">Membre actif </span>
                        <small >Unicef Calais(de décembre à juin 2022)</small>
                        </div>
                    </a>
                
                    </div>
                </div>
              </div>
          </div>
          <div class="col-12 order-first offset-md-1 col-md-7 order-md-last">

            <!-- Progress bar -->
            <div class="mb-3 p-3 bg-white rounded-3 shadow-sm">
              <div class="row align-items-center">
                <div class="col-5 col-sm-4 col-lg-3 col-xl-2">
                  <div class="d-flex align-items-center">
                    <font-awesome-icon icon="fa-brands fa-bootstrap" />
                    <p class="fw-bold m-0">Bootstrap</p>
                  </div>
                </div>
                <div class="col">
                  <div class="progress" data-bs-toggle="tooltip" title="75%">
                    <div class="progress-bar w-75" role="progressbar" aria-valuenow="75" aria-valuemin="0"
                         aria-valuemax="100">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3 p-3 bg-white rounded-3 shadow-sm">
              <div class="row align-items-center">
                <div class="col-5 col-sm-4 col-lg-3 col-xl-2">
                  <div class="d-flex align-items-center">
                    
                    <p class="fw-bold m-0">Django</p>
                  </div>
                </div>
                <div class="col">
                  <div class="progress" data-bs-toggle="tooltip" title="100%">
                    <div class="progress-bar w-75" role="progressbar" aria-valuenow="100" aria-valuemin="0"
                         aria-valuemax="100">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3 p-3 bg-white rounded-3 shadow-sm">
              <div class="row align-items-center">
                <div class="col-5 col-sm-4 col-lg-3 col-xl-2">
                  <div class="d-flex align-items-center">
                    <font-awesome-icon icon="fa-brands fa-symfony" />
                    <p class="fw-bold m-0">Symfony</p>
                  </div>
                </div>
                <div class="col">
                  <div class="progress" data-bs-toggle="tooltip" title="75%">
                    <div class="progress-bar w-75" role="progressbar" aria-valuenow="75" aria-valuemin="0"
                         aria-valuemax="100">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3 p-3 bg-white rounded-3 shadow-sm">
              <div class="row align-items-center">
                <div class="col-5 col-sm-4 col-lg-3 col-xl-2">
                  <div class="d-flex align-items-center">
                    <font-awesome-icon icon="fa-brands fa-vuejs" />
                    <p class="fw-bold m-0">Vue js</p>
                  </div>
                </div>
                <div class="col">
                  <div class="progress" data-bs-toggle="tooltip" title="75%">
                    <div class="progress-bar w-75" role="progressbar" aria-valuenow="75" aria-valuemin="0"
                         aria-valuemax="100">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3 p-3 bg-white rounded-3 shadow-sm">
              <div class="row align-items-center">
                <div class="col-5 col-sm-4 col-lg-3 col-xl-2">
                  <div class="d-flex align-items-center">
                    <font-awesome-icon icon="fa-brands fa-wordpress" />
                    <p class="fw-bold m-0">WordPress</p>
                  </div>
                </div>
                <div class="col">
                  <div class="progress" data-bs-toggle="tooltip" title="75%">
                    <div class="progress-bar w-75" role="progressbar" aria-valuenow="75" aria-valuemin="0"
                         aria-valuemax="100">
                    </div>
                  </div>
                </div>
              </div>
            </div>

          
          </div>

        </div>
      </div>
      
    </section>
</template>

<script>
export default {
      name: 'SkillsView'
}
</script>

<style>
.mg{
  font-size:100px;

}
.progress-bar
{
  background-color: #bd6513;
  color: #bd6513;
}
</style>
